import {connect} from "react-redux";
import RouteMapPoint from "./RouteMapPoint";
import {excludePassthroughPoint} from "../../store/actions";

const mapStateToProps = state => ({
  
});

const mapDispatchToProps = dispatch => ({
  excludePassthroughPoint: index => dispatch(excludePassthroughPoint(index))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RouteMapPoint);

